import { Money, ProductConditionCode, UrgencyCode } from "../../../common/models/CommonModels";
import { Page, QueryBase } from "../../../shared/models/models";
import { VisibilityPresetCode } from "../shared/models/models";

export interface CustomerMyRfqsState {
  query: RfqsQuery;
  rfqs?: Page<Rfq>;
  rfq?: Rfq;
  manufacturers: ManufacturerReference[],
  categories: CategoryReference[],
  loading: boolean;
  success?: string;
  error: any;
}

export interface Rfq {
  id: string;
  productNumber: string;
  productAlternativeNumber: string;
  category: CategoryReference;
  manufacturer: ManufacturerReference;
  maxUnitPrice: Money;
  quantity: number;
  urgencyCode: UrgencyCode;
  number: string;
  createdDate: Date;
  lastCall: Date;
  statusCode: RfqStatusCode;
  offersCount: number;
  matchesCount: number;
  productConditionCodes: ProductConditionCode[];
}

export interface ChangeRfq {
  productNumber: string;
  productAlternativeNumber?: string;
  categoryId: string;
  manufacturerId: string;
  maxUnitPrice?: Money;
  quantity?: number;
  description: string;
  urgencyCode: UrgencyCode;
  lastCall?: Date;
  productConditionCodes: ProductConditionCode[];
}

export interface ManufacturerReference {
  id: string;
  name: string;
}

export interface CategoryReference {
  id: string;
  name: string;
}

export interface RfqsQuery extends QueryBase<RfqQueryParameter> {
  search?: string;
  statusCodes: RfqStatusCode[];
  lastCallTo?: string;
  visibilityCode: VisibilityPresetCode;
}

export enum RfqStatusCode {
  open = 1,
  closed = 2,
  confirmed = 3,
  archived = 4
}

export enum RfqQueryParameter {
  urgency = 1,
  productNumber = 2
}

export enum RfqCode {
  public = 1,
  customCompanyList = 2
}

class UrgencyStatuses {
  private readonly map = {} as any;

  constructor() {
    this.map[UrgencyCode.emergency] = "Emergency";
    this.map[UrgencyCode.nextDay] = "Next Day";
    this.map[UrgencyCode.twoThreeDays] = "2-3 days";
    this.map[UrgencyCode.fourSixDays] = "4-6 days";
    this.map[UrgencyCode.thisWeek] = "This week";
    this.map[UrgencyCode.nextWeek] = "Next week";
    this.map[UrgencyCode.any] = "Any";
  }

  urgencyStatus = (code: UrgencyCode) => {
    return this.map[code] || "";
  };
}
export const { urgencyStatus } = new UrgencyStatuses();

class RfqStatuses {
  private readonly map = {} as any;

  constructor() {
    this.map[RfqCode.public] = "Keep my RFQ public";
    this.map[RfqCode.customCompanyList] = "Custom company list";
  }

  RfqStatus = (code: RfqCode) => {
    return this.map[code] || "";
  };
}

export const { RfqStatus } = new RfqStatuses();

export const isRfqsQueryEmpty = (query: RfqsQuery): boolean => {
  return !query.search &&
    !query.lastCallTo &&
    !query.statusCodes?.length;
};